var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.692,
    height: 25.933,
    viewBox: "0 0 22.692 25.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M5.673,8.1V5.673a5.673,5.673,0,1,1,11.346,0V8.1h3.242a2.432,2.432,0,0,1,2.431,2.431V21.071a4.864,4.864,0,0,1-4.863,4.863H4.863A4.863,4.863,0,0,1,0,21.071V10.535A2.432,2.432,0,0,1,2.431,8.1ZM8.1,8.1h6.483V5.673a3.242,3.242,0,1,0-6.483,0ZM2.431,10.535V21.071A2.432,2.432,0,0,0,4.863,23.5H17.829a2.432,2.432,0,0,0,2.431-2.431V10.535H17.019v2.836a1.216,1.216,0,0,1-2.431,0V10.535H8.1v2.836a1.216,1.216,0,0,1-2.431,0V10.535Z",
    fill: "#777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.762917b589a30fe190b0228edefaa3df.svg";
export { ForwardRef as ReactComponent };